import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Navigation from "./components/Navigation";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import Home from "./pages/Home";
import CertificationQualiopi from "./pages/CertificationQualiopi";
import Contact from "./pages/Contact";
import ConseillerNumerique from "./pages/ConseillerNumerique";
import FacilitateurTiersLieu from "./pages/FacilitateurTiersLieu";
import PiloterTiersLieu from "./pages/PiloterTiersLieu";
import TesteurLogiciel from "./pages/TesteurLogiciel";
import MentionsLegales from "./pages/MentionsLegales";
import NotFound from "./pages/NotFound";
import PolitiqueConfidentialite from "./pages/PolitiqueConfidentialite";
import Candidater from "./pages/Candidater";
import ResponsableEspacesMN from "./pages/ResponsableEspacesMN";
import NosFormations from "./pages/NosFormations";
import QuiSommesNous from "./pages/QuiSommesNous";
import CookiesBanner from './components/CookiesBanner';
import SpeechButton from './components/SpeechButton';
import './styles/speechSynthesis.scss';

const App = () => {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <CookiesBanner />
      <Navigation />
      {/* Bouton de lecture globale fixe */}
      <SpeechButton 
        readFullPage={true}
        className="speech-button speech-button-fixed"
      >
        <span className="speech-icon">🔊</span>
        <span className="speech-text">Écouter la page</span>
      </SpeechButton>
      {/* Container principal avec ID pour la lecture */}
      <div id="main">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/nos-formations" element={<NosFormations />} />
          <Route path="/conseiller-numerique" element={<ConseillerNumerique />} />
          <Route path="/responsable-espaces-mediation-numerique" element={<ResponsableEspacesMN />} />
          <Route path="/facilitateur-de-tiers-lieu" element={<FacilitateurTiersLieu />} />
          <Route path="/piloter-un-tiers-lieu" element={<PiloterTiersLieu />} />
          <Route path="/testeur-logiciel" element={<TesteurLogiciel />} />
          <Route path="/certification-qualiopi" element={<CertificationQualiopi />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/mentions-legales" element={<MentionsLegales />} />
          <Route path="/politique-de-confidentialite" element={<PolitiqueConfidentialite />} />
          <Route path="/erreur-404" element={<NotFound />} />
          <Route path="/candidater" element={<Candidater />} />
          <Route path="/qui-sommes-nous" element={<QuiSommesNous />} />
        </Routes>
      </div>
      <Footer />
    </BrowserRouter >
  );
};

export default App;
